// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3nLrZ","right":"styles_right__2Gsim"};